<template>
  <div id="page" :class="[isLight ? 'lightmode' : 'darkmode']">
    <div v-if="isMenuShown" class="darker-film" @click="toggleMenuMobile"></div>
    <sidebar-navigator @change-theme="changeTheme" 
                       @toggle-menu-mobile="toggleMenuMobile" 
                       @change-calc="changeCalc" 
                       :menu-shown="isMenuShown"
                       :dark-mode="isLight"
                       :selected-calc="selectedCalc"/>
    <navigation-bar @toggle-menu-mobile="toggleMenuMobile" @change-theme="changeTheme" :dark-mode="isLight"/>
    <unit-convertion v-if="selectedCalc === 4" :dark-mode="isLight"/>
    <info-footer />
  </div>
</template>

<script setup>
  import { ref,computed,onMounted, onUnmounted } from "vue";
  import SidebarNavigator from "./SidebarNavigator.vue";
  import InfoFooter from "./InfoFooter.vue";
  import UnitConvertion from "./UnitConvertion.vue";
  import NavigationBar from "./NavigationBar.vue";
  import { timeCalculatorSettings } from "@/stores/TimeCalculatorStore";

  var isLight = computed(() => timeCalculatorSettings().lightMode);
  var isMenuShown = ref(false);
  var selectedCalc = ref(4);

  const changeTheme = () =>
  {
    timeCalculatorSettings().changeTheme();
  }

  const toggleMenuMobile = () =>
  {
    isMenuShown.value = !isMenuShown.value;

    if(isMenuShown.value)
    {
      document.body.classList.add('menu-shown');
    }

    else
    {
      document.body.classList.remove('menu-shown');
    }
  }

  const changeToDesktop = () =>
  {
    if (window.innerWidth > 770) 
    {
        isMenuShown.value = false;
        document.body.classList.remove('menu-shown');
    }
  }

  onMounted(() => 
  {
    changeToDesktop();
    window.addEventListener('resize',changeToDesktop);
    document.body.classList.remove('menu-shown');
  });

  onUnmounted(() =>
  {
    window.removeEventListener('resize',changeToDesktop);
    document.body.classList.remove('menu-shown');
  });
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Syne');
  #page
  {
    display: grid;
    min-height:100dvh;
    width:100vw;
    padding:0;
    margin:0;
    grid-template-columns: 1fr;
    grid-template-rows:67px auto 50px;
  }

  #page.lightmode
  {
    background-color: #F0F0F0;
  }

  #page.darkmode
  {
    background-color: #2b3133;
  }

  .darker-film
  {
    grid-area: 1 / 1 / -1 / 2;
    z-index:6;
    background-color: rgba(128, 128, 128, 0.4);
    transition: 0.1s all;
  }

  @media screen and (min-width: 770px)
  {
    #page
    {
      width: 100vw;
      grid-template-columns: 100vw;
    }
  }
</style>
